export default "__VITE_ASSET__C4hcJ_MY__"